import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { RangePrice } from 'features/input-range'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import {
  DifficultList,
  DifficultTypes,
  DurationList,
  DurationTypes,
} from 'shared/constants/excursions'

import { FilterUi } from './components/filter-ui'

const Filter = observer(() => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const onSubmit = () => {
    navigate(RoutingPaths.excursion.search.path())

    listExcursionStore.resetList()
  }

  const onReset = () => {
    findExcursionsStore.onResetFilter()
  }

  const onBack = () => {
    navigate(-1)
  }

  const showGuides = () => {
    navigate(RoutingPaths.excursion.filterCarrier.path())
  }

  const onChangeDuration = (type: string | string[]) => {
    findExcursionsStore.onSetDuration(type as DurationTypes)
  }

  const onChangeDifficult = (type: string | string[]) => {
    findExcursionsStore.onSetDifficult(type as DifficultTypes)
  }

  const onRange = (data: RangePrice) => {
    findExcursionsStore.onSetRangePrice(data)
  }

  const onSelectTypeExcursions = (data: string | string[]) => {
    findExcursionsStore.onSetTypesExcursions(data as string[])
  }

  const listTypeOfExcursions = useMemo(
    () =>
      listExcursionStore.excursionsFilter?.excursion_types?.map((item) => ({
        key: item.key,
        title: item.value,
      })),
    [],
  )

  const minMaxPrice = {
    min: Number(
      listExcursionStore.excursionsFilter?.price_range.price_min || 0,
    ),
    max: Number(
      listExcursionStore.excursionsFilter?.price_range.price_max || 0,
    ),
  }
  return (
    <FilterUi
      priceRange={minMaxPrice}
      listDuration={DurationList.map((option) => ({
        title: t(option.title),
        key: option.key,
      }))}
      listTypeOfExcursions={listTypeOfExcursions}
      listDifficult={DifficultList.map((option) => ({
        title: t(option.title),
        key: option.key,
      }))}
      onSubmit={onSubmit}
      onBack={onBack}
      onReset={onReset}
      onChangeDuration={onChangeDuration}
      onChangeDifficult={onChangeDifficult}
      showGuides={showGuides}
      onRangePrice={onRange}
      onSelectTypeExcursions={onSelectTypeExcursions}
    />
  )
})

export default Filter
